import { render } from "./ModalHierarchy.vue?vue&type=template&id=127ef5b6"
import script from "./ModalHierarchy.vue?vue&type=script&lang=js"
export * from "./ModalHierarchy.vue?vue&type=script&lang=js"

import "./ModalHierarchy.vue?vue&type=style&index=0&id=127ef5b6&lang=css"
script.render = render

export default script